<!-- List Tags as chips with a 'remove' button on them. -->
<template>
  <v-layout
    v-bind="layout"
    style="line-height: normal; flex-wrap: wrap; align-items: start"
    :style="{
      'flex-direction': collapsed && !column ? 'row' : 'column',
    }"
  >
    <v-chip
      v-for="tag in limitedTags"
      :key="'tag-list-item-' + tag.id"
      :color="getTagColor(tag)"
      small
      :close="removable"
      :title="removable ? $t(removableTooltip) : ''"
      :class="{'v-chip--xs': xs}"
      data-cy="tag-select-list-tag-chip"
      @input="$emit('remove', tag)"
    >
      <span :style="{color: getTagTextColor(tag)}">{{ tag.name }}</span>
    </v-chip>
    <v-chip
      v-if="showToggleCollapsedButton"
      small
      :title="collapsed ? $t('tagsExpandAll') : $t('tagsCollapseAll')"
      class="clickable font-weight-bold"
      :class="{'v-chip--xs': xs}"
      @click.stop="toggleCollapsed()"
    >
      <span v-if="collapsed"> + {{ numCollapsedTags }} </span>
      <v-icon v-if="collapsed">
        expand_more
      </v-icon>
      <v-icon v-else>
        expand_less
      </v-icon>
    </v-chip>
  </v-layout>
</template>

<script>
import orderBy from 'lodash.orderby';

import tagsMixin from '@/mixins/tags';

const COLLAPSE_FOR_MORE_THAN = 3;

export default {
  mixins: [tagsMixin],
  props: {
    tags: {
      type: Array[Object],
      required: true,
    },
    removable: {
      type: Boolean,
      default: false,
    },
    removableTooltip: {
      type: String,
      default: 'removeTagFromSpot',
    },
    xs: {
      type: Boolean,
      default: false,
    },
    collapsible: {
      type: Boolean,
      default: true,
    },
    column: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapsed: true,
    };
  },
  computed: {
    layout() {
      const layout = {};
      if (this.column) {
        layout.column = true;
      }
      return layout;
    },
    tagsSortedByName() {
      return orderBy(this.tags, [(tag) => tag.name.toLowerCase()]);
    },
    limitedTags() {
      if (this.collapsible && this.collapsed) {
        return this.tagsSortedByName.slice(0, COLLAPSE_FOR_MORE_THAN);
      }
      return this.tagsSortedByName;
    },
    numCollapsedTags() {
      return this.tags.length - this.limitedTags.length;
    },
    showToggleCollapsedButton() {
      return this.collapsible && this.tags.length > COLLAPSE_FOR_MORE_THAN;
    },
  },
  methods: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>

<style scoped>
.v-chip--xs {
  height: 20px !important;
  margin: 2px;
}
.v-chip.v-chip--xs >>> .v-chip__content {
  font-size: smaller;
}
</style>



// WEBPACK FOOTER //
// src/components/TagSelectList.vue